import React from "react";
import "./App.css";

function SkeletonLoader() {
  return (
    <div className="skeleton-container">
      {/* Compact Navbar Skeleton */}
      <nav className="navbar">
        <div className="navbar-brand">
          <div className="skeleton-box" style={{ width: 24, height: 24, borderRadius: "50%" }} />
          <div className="skeleton-box" style={{ width: 140, height: 16 }} />
        </div>
        <div className="navbar-links">
          <div className="skeleton-box" style={{ width: 110, height: 26, borderRadius: 14 }} />
          <div className="skeleton-box" style={{ width: 110, height: 26, borderRadius: 14 }} />
          <div className="skeleton-box" style={{ width: 110, height: 26, borderRadius: 14 }} />
          <div className="skeleton-box" style={{ width: 110, height: 26, borderRadius: 14 }} />
        </div>
        <div className="navbar-user">
          <div className="skeleton-box" style={{ width: 24, height: 24, borderRadius: "50%" }} />
          <div className="skeleton-box" style={{ width: 60, height: 14 }} />
        </div>
      </nav>

      {/* Main Skeleton Body */}
      <div className="skeleton-main-body">
        {/* Left Operations Control Panel Skeleton */}
        <aside className="skeleton-left-panel">
          <div className="skeleton-box" style={{ width: "60%", height: 14, marginBottom: 18 }} />
          <div className="skeleton-box" style={{ width: "100%", height: 38, marginBottom: 18, borderRadius: 8 }} />
          <div className="skeleton-box" style={{ width: "100%", height: 110, marginBottom: 18, borderRadius: 8 }} />
          <div className="skeleton-box" style={{ width: "100%", height: 42, borderRadius: 8 }} />
        </aside>

        {/* Right Table Panel Skeleton */}
        <main className="skeleton-right-panel">
          <div className="skeleton-table-header">
            <div className="skeleton-box" style={{ width: 70, height: 14 }} />
            <div className="skeleton-box" style={{ width: 110, height: 14 }} />
            <div className="skeleton-box" style={{ width: 80, height: 14 }} />
            <div className="skeleton-box" style={{ width: 60, height: 14 }} />
            <div className="skeleton-box" style={{ width: 60, height: 14 }} />
            <div className="skeleton-box" style={{ width: 140, height: 14 }} />
          </div>
          {[1, 2, 3, 4, 5].map((idx) => (
            <div key={idx} className="skeleton-table-row">
              <div className="skeleton-box" style={{ width: 85, height: 22, borderRadius: 12 }} />
              <div className="skeleton-box" style={{ width: 120, height: 16 }} />
              <div className="skeleton-box" style={{ width: 90, height: 14 }} />
              <div className="skeleton-box" style={{ width: 45, height: 14 }} />
              <div className="skeleton-box" style={{ width: 45, height: 14 }} />
              <div className="skeleton-box" style={{ width: 130, height: 26, borderRadius: 6 }} />
            </div>
          ))}
        </main>
      </div>
    </div>
  );
}

export default SkeletonLoader;
